import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../lib/api";
import { formatKr, fmtSlots, slotsOf } from "../lib/format";
import StackTable from "../components/StackTable";
import { Thumb } from "../components/bits";

export default function Picklist() {
  const { id } = useParams();
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get(`/offers/${id}/picklist`).then((r) => setD(r.data));
  }, [id]);

  if (!d) return <div className="loading">Indlæser…</div>;
  const { offer, orders, total } = d;

  return (
    <>
      <div className="page-head">
        <Thumb offer={offer} />
        <div>
          <h1>Plukliste · {offer.title}</h1>
          <p>
            Afhentning {fmtSlots(slotsOf(offer))} · {orders.length} kunder ·{" "}
            <b>{total} stk. i alt</b>
            {d.by_variant?.length > 0 && (
              <span data-testid="picklist-variants"> · {d.by_variant.map((v) => `${v.name}: ${v.qty}`).join(" · ")}</span>
            )}
          </p>
        </div>
        <div className="actions no-print">
          <Link className="btn" to={`/offers/${offer.id}`}>
            Tilbage
          </Link>
          <button className="btn primary" onClick={() => window.print()}>
            Print
          </button>
        </div>
      </div>
      <section className="panel">
        <div className="table-wrap">
          <StackTable>
            <thead>
              <tr>
                <th style={{ width: 30 }}></th>
                <th>Navn</th>
                <th>Kode</th>
                <th className="num">Antal</th>
                <th className="num">Beløb</th>
                <th>Note</th>
              </tr>
            </thead>
            <tbody>
              {orders.length ? (
                orders.map((o) => (
                  <tr className={o.status === "picked_up" ? "done" : ""} key={o.id}>
                    <td>
                      <span className="box" />
                    </td>
                    <td>{o.name}{o.name_source === "customer" && <span className="by-customer">(skrevet af kunden)</span>}</td>
                    <td>
                      <span className="code">{o.code}</span>
                    </td>
                    <td className="num">
                      <b>{o.qty}</b>
                      {o.variant_name && <span className="vn-tag">{o.variant_name}</span>}
                    </td>
                    <td className="num">{formatKr(o.amount)}</td>
                    <td>{o.status === "pending_confirm" ? "Ikke bekræftet" : o.status === "picked_up" ? "Hentet" : ""}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="empty">
                    Ingen reservationer
                  </td>
                </tr>
              )}
            </tbody>
          </StackTable>
        </div>
      </section>
    </>
  );
}
